import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { authClient } from "./auth";
import { ThemeToggle } from "./components/ThemeToggle";
import { MeProvider } from "./me";

const NAV = [
  { to: "/watchlists", label: "Watchlists" },
  { to: "/chart", label: "Chart" },
  { to: "/screener", label: "Screener" },
  { to: "/picks", label: "Picks" },
  { to: "/jobs", label: "Jobs" },
] as const;

export function Shell() {
  const { data } = authClient.useSession();
  const navigate = useNavigate();

  async function signOut() {
    await authClient.signOut();
    navigate("/login", { replace: true });
  }

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand-block">
          <img className="brand-mark" src="/icon.svg" alt="" width={30} height={30} />
          <div>
            <h1 className="brand">Alpha Terminal</h1>
            <p className="brand-sub">4AM Wealth</p>
          </div>
        </div>
        <nav aria-label="Main">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={({ isActive }) => (isActive ? "nav active" : "nav")}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="user">
          <ThemeToggle />
          <span>{data?.user.email}</span>
          <button type="button" className="btn small" onClick={signOut}>
            Sign out
          </button>
        </div>
      </aside>
      <main className="content">
        <MeProvider>
          <Outlet />
        </MeProvider>
      </main>
    </div>
  );
}
